import React from 'react'
import {Row, Col} from 'antd'
import './index.less'

export default (props)=>(
    <Row gutter={props.gutter || 10} className='form-control'>
        <Col span={24 - (props.span || 18)} className='text-right'>
            <label>{props.label}</label>
        </Col>
        <Col span={props.span || 18}>
            {props.children}
        </Col>
    </Row>
)


// WEBPACK FOOTER //
// ./src/components/elements/FormGroup/index.js